import { pagesConfig } from '../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../shared/analytics/module-list';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ClickableCard from '../../shared/clickable-card';
import { Outlet, useNavigate } from 'react-router-dom';
import { useRouteMatch } from '../../shared/useRouteMatch';

export default function InsightsHelpfulInformationPage() {
  const navigate = useNavigate();
  const BREADCRUMBS = [
    { label: ModuleList.modules.insights.name },
    { label: pagesConfig.insightsHelpfulInformation.name },
  ];

  const insightsHelpfulInfoLink = `${pagesConfig.insights.link}/${pagesConfig.insightsHelpfulInformation.link}`;
  const isSubPageClicked = useRouteMatch([
    `/${insightsHelpfulInfoLink}/${pagesConfig.insightsReleaseNotes.link}`,
  ]);

  const insightsCards = [pagesConfig.insightsReleaseNotes].map(
    ({ name, link }) => ({
      title: name,
      path: `/${insightsHelpfulInfoLink}/${link}`,
    })
  );

  if (isSubPageClicked) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage breadcrumbs={BREADCRUMBS} shouldAllowHeightToScroll>
      <Box p={1}>
        <Typography variant="body1">
          Meta tools and dashboards about Promevo Insights.
        </Typography>
        <Stack
          direction="row"
          sx={{
            mt: 3,
            gap: 3,
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {insightsCards.map(({ title, path }) => (
            <ClickableCard
              key={path}
              title={title}
              onClick={() => navigate(path)}
            />
          ))}
        </Stack>
      </Box>
    </SimpleBreadcrumbsPage>
  );
}
